import { configureStore } from "@reduxjs/toolkit"
import { setAutoFreeze } from "immer"
import reducer from "./reducer"

// The app stores non-serializable class instances (Place, Guide, the Google Maps
// map reference) in Redux state. Immer's auto-freeze in development mode makes
// those objects immutable, causing TypeErrors whenever code mutates them outside
// a reducer (e.g. map.fitBounds() modifying internal map state, or direct Place
// property assignments). Disabling auto-freeze prevents those crashes.
setAutoFreeze(false)

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }),
})

export default store
